// Standard footer for manually-paginated (server-side) tables. Renders MUI
// TablePagination so it matches the DataGrid footer used across the app
// ("Rows per page: N   1–N of total   < >").
//
// `page` is 1-indexed to match the existing server-pagination state in these
// pages. Pass `count` (total rows) when the API provides it; otherwise pass
// `totalPages` and it derives an approximate count so navigation still works.

import React from "react";
import TablePagination from "@mui/material/TablePagination";

const TablePager = ({
  count,
  totalPages,
  page = 1,
  rowsPerPage = 10,
  onPageChange,
  rowsPerPageOptions,
}) => {
  const resolvedCount =
    typeof count === "number" && count >= 0
      ? count
      : Math.max(0, (totalPages || 1) * rowsPerPage);

  return (
    <TablePagination
      component="div"
      count={resolvedCount}
      page={Math.max(0, (page || 1) - 1)}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions ?? [rowsPerPage]}
      onPageChange={(event, newPage) => onPageChange && onPageChange(newPage + 1)}
    />
  );
};

export default TablePager;
